export default class Inventory {
  readonly id: number;

  readonly title: string;

  readonly image: string;

  readonly canBeTraded: boolean;

  constructor(id: number, title: string, image: string, canBeTraded: boolean) {
    this.id = id;
    this.title = title;
    this.image = image;
    this.canBeTraded = canBeTraded;
  }
}
